export default "__VITE_ASSET__CJU9O_I$__"